import {gql} from "apollo-angular";
import {baseResponse, baseResponseGraphqlField} from "../../../base.graphql";
import {currencyTypeFields} from "../../system-settings/currency-type/currency-type.graphql";


export const serviceBillingDetailsFields = `
id
billingUniqueId
billingScheme
billingCurrencies {
  ${currencyTypeFields}
}
billingHasVariation
billingVariationReasons
`

export const CREATE_SERVICE_BILLING_DETAILS = gql`
  mutation CreateServiceBillingDetails($input: ServiceBillingDetailsInputObjects!) {
    createServiceBillingDetails(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${serviceBillingDetailsFields}
      }
    }
  }
`

export const UPDATE_SERVICE_BILLING_DETAILS = gql`
  mutation UpdateServiceBillingDetails($input: ServiceBillingDetailsInputObjects!) {
    updateServiceBillingDetails(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${serviceBillingDetailsFields}
      }
    }
  }
`

export const DELETE_SERVICE_BILLING_DETAILS = gql`
  mutation DeleteServiceBillingDetails($billingUniqueId: String!) {
    deleteServiceBillingDetails(billingUniqueId: $billingUniqueId) {
      ${baseResponseGraphqlField}
    }
  }
`

export const GET_SERVICE_BILLING_DETAILS = gql`
  query GetInstitutionServiceBillings($filtering: ServiceBillingDetailsFilterInputObject) {
    getInstitutionServiceBillings(filtering: $filtering) {
      ${baseResponseGraphqlField}
      data {
        ${serviceBillingDetailsFields}
      }
    }
  }
`

export const CITIZEN_GET_INSTITUTION_SERVICE_BILLINGS = gql`
  query CitizenGetInstitutionServiceBillings($filtering: ServiceBillingDetailsFilterInputObject) {
    citizenGetInstitutionServiceBillings(filtering: $filtering) {
      response {
        ${baseResponse}
      }
      data {
        ${serviceBillingDetailsFields}
      }
    }
  }
`;
